import { ManifestResolver, type RawManifest } from '@pp/toolkit';

import { Fetcher } from '../../../api/Fetcher';
import { getStaticBaseUrl } from '../../../utils/getStaticBaseUrl';
import type { FeatureConfigList } from '../types';

import type { FeatureServiceFetcher } from './types';

export class JSONFetcher implements FeatureServiceFetcher {
  constructor(
    private casinoId: string,
    private config?: string | string[]
  ) {}

  fetch(): Promise<FeatureConfigList> {
    if (!this.config) {
      return Promise.resolve({});
    }

    const manifestResolver = new ManifestResolver({
      casinoId: this.casinoId,
    });

    const configsToLoad =
      this.config instanceof Array ? this.config.map(this.getFeatureURL) : [this.getFeatureURL(this.config)];
    return Promise.all(configsToLoad.map((url) => Fetcher.fetch<RawManifest>(url))).then((manifests: RawManifest[]) => {
      const resolvedManifests = manifests.map((manifest) => manifestResolver.resolve(manifest));
      return ManifestResolver.merge(...resolvedManifests).flags;
    });
  }

  getFeatureURL(name: string): string {
    const { base } = getStaticBaseUrl();

    return `${base}/apps/feature-flags/1.0.0/${name}.manifest.json?2`;
  }
}
